<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
               <h4 class="card-title">Listing Wizard</h4>
            </div>
            <div class="card-body">
              <ListingForm />
            </div>
          </div>
        </div>
      </div>
     </div>
  </div>
</template>
  
  <script>
  import ListingForm from '@/components/ListingForm.vue';
  
  // import LotSelect from '@/components/LotSelect.vue';


  
  export default {
    name: 'Listing-Form',
    components: {
      ListingForm,
      
    },
    data(){
      return {
        ShowSelectEvent: true,
        ShowSelectLot:false
      };
    },
    methods:{
      toggleComponent(){
        this.ShowSelectEvent = !this.ShowSelectEvent;
        this.ShowSelectLot = !this.ShowSelectLot;

      }
    }
  };
  </script>
  